import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SEU_ENVIRONMENT } from '@seu-environment';
import { SEU_API_ENDPOINTS } from '@seu-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  constructor(private httpClient: HttpClient) {}

  public post<ResponseData, RequestData = unknown>(
    endpoint: SEU_API_ENDPOINTS,
    data: RequestData
  ): Observable<ResponseData> {
    return this.httpClient.post<ResponseData>(
      `${SEU_ENVIRONMENT.apiUrl}${endpoint}`,
      data
    );
  }

  public put<ResponseData, RequestData = unknown>(
    endpoint: SEU_API_ENDPOINTS,
    data: RequestData
  ): Observable<ResponseData> {
    return this.httpClient.put<ResponseData>(
      `${SEU_ENVIRONMENT.apiUrl}${endpoint}`,
      data
    );
  }

  public get<ResponseData>(
    endpoint: SEU_API_ENDPOINTS
  ): Observable<ResponseData> {
    return this.httpClient.get<ResponseData>(
      `${SEU_ENVIRONMENT.apiUrl}${endpoint}`
    );
  }

  public delete<ResponseData>(
    endpoint: SEU_API_ENDPOINTS
  ): Observable<ResponseData> {
    return this.httpClient.delete<ResponseData>(
      `${SEU_ENVIRONMENT.apiUrl}${endpoint}`
    );
  }
}
